var configs = {
    //本地开发环境的服务器地址(npm run dev)
    dev: {
        domain: '',
    },
    //生产环境的接口地址:当前目录
    prod: {
        domain: '',
    }
}
module.exports = configs[process.env.ENV_CONFIG]

